var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShare16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "share-16_svg__lucide share-16_svg__lucide-share-2",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 5,
  r: 3
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 12,
  r: 3
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 19,
  r: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8.59 13.51 6.83 3.98M15.41 6.51l-6.82 3.98"
})));
export default SvgShare16;